import { cn } from "@design-system/Utilities";
import {
    type FC,
    type InputHTMLAttributes,
    type Ref,
    useImperativeHandle,
    useRef,
} from "react";

import { FieldWrapper, type SharedProps } from "./FieldWrapper";

export interface TextfieldProps
    extends InputHTMLAttributes<HTMLInputElement>,
        SharedProps {}
export const Textfield: FC<
    TextfieldProps & { ref?: Ref<HTMLInputElement> }
> = ({
    className,
    hint,
    success,
    error,
    placeholder,
    ref,
    required,
    ...props
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);
    const placeholderUp = props.value != null || props.defaultValue != null;

    return (
        <FieldWrapper
            inputRef={inputRef}
            placeholder={placeholder}
            hint={hint}
            success={success}
            error={error}
            disabled={props.disabled}
            htmlFor={props.id}
            placeholderUp={placeholderUp}
            required={required}
        >
            <input
                className={cn(
                    "bg-transparent w-full p-0 font-default text-base font-regular leading-[20px] border-0 focus:ring-0 placeholder:text-neutral-500 resize-none disabled:text-neutral-500",
                    className,
                )}
                ref={inputRef}
                required={required}
                {...props}
            />
        </FieldWrapper>
    );
};
